import { msgs } from "../define";

export const owner = msgs({
  en: {
    "overview.greeting.morning": "Good morning, {name}",
    "overview.greeting.afternoon": "Good afternoon, {name}",
    "overview.greeting.evening": "Good evening, {name}",
    "overview.sub": "{branch} · today",
    "overview.collected": "Collected today",
    "overview.appointments": "Appointments today",
    "overview.appointments.sub": "{n} completed",
    "overview.avgTicket": "Average sale",
    "overview.avgTicket.sub": "{n} paid sales",
    "overview.newCustomers": "New customers",
    "overview.newCustomers.sub": "Last 7 days",
    "overview.actions": "To do",
    "overview.allClear": "You're all caught up.",
    "overview.allClear.sub": "New tasks — unpaid deposits, held sales, setup steps — show up here.",
    "overview.newSale": "New sale",
    "overview.noBranch": "Add a location in Settings to see today's numbers.",
    "overview.action.verify_email": "Confirm your email address",
    "overview.action.pending_deposits": "{n} bookings waiting for a deposit",
    "overview.action.held_sales": "{n} sales on hold",
    "overview.action.connect_payments": "Choose how you take card payments",
    "overview.action.add_services": "Add your services",
    "overview.action.add_team": "Invite your team",
    "settings.title": "Settings",
    "settings.tab.salon": "Salon",
    "settings.tab.locations": "Locations",
    "settings.tab.payments": "Payments",
    "settings.tab.plan": "Plan & billing",
    "settings.salon.title": "Salon profile",
    "settings.salon.sub": "Name, logo and the defaults used for new locations.",
    "settings.salon.saved": "Salon profile saved",
    "settings.salon.removeLogo": "Remove logo",
    "settings.salon.subscriptionUsd": "Your Senvia POS subscription is billed in USD whatever currency you sell in.",
    "settings.locations.title": "Locations",
    "settings.locations.sub": "Opening hours, time zone, tax and checkout rules per location.",
    "settings.locations.add": "Add location",
    "settings.locations.hours": "Opening hours",
    "settings.locations.region": "Region",
    "settings.locations.checkout": "Checkout",
    "settings.locations.inherit": "Same as salon ({value})",
    "settings.locations.locked": "Locked",
    "settings.locations.lockedBody": "This location has sales, so its currency can't change. Open a new location to sell in another currency.",
    "settings.locations.discountLimit": "Cashier discount limit (%)",
    "settings.locations.noTax": "No tax",
    "settings.locations.incl": "incl.",
    "settings.locations.excl": "excl.",
    "settings.locations.saved": "Location saved",
    "settings.locations.created": "Location added",
    "settings.locations.planLimit": "Your plan includes one location. Add the Additional branch add-on to open more.",
    "settings.locations.closedDays": "Closed",
    "settings.payments.title": "Payments",
    "settings.payments.explain": "Customer card payments go to your own Stripe account. The platform never holds your money.",
    "settings.payments.connect": "Connect Stripe",
    "settings.payments.tutorial": "Step-by-step guide",
    "settings.payments.stub": "Stripe connection is in preview in this version — no real account is created yet.",
    "settings.payments.manual": "Cash & manual payments only",
    "settings.payments.manualOn": "You're taking cash and manual payments. You can connect Stripe any time.",
    "settings.payments.status.not_connected": "Not connected",
    "settings.payments.status.pending": "Verification pending",
    "settings.payments.status.restricted": "Action required",
    "settings.payments.status.active": "Connected",
    "settings.plan.title": "Plan & billing",
    "settings.plan.current": "Current plan",
    "settings.plan.perMonth": "{price} / month",
    "settings.plan.trialEnds": "Trial ends {date}",
    "settings.plan.addons": "Active add-ons",
    "settings.plan.noAddons": "No add-ons yet.",
    "settings.plan.browse": "Browse add-ons",
    "settings.plan.billingLater": "Online billing for your subscription arrives soon. Nothing is charged during the trial.",
    "team.title": "Team",
    "team.sub": "People who take appointments or use the till.",
    "team.add": "Add team member",
    "team.edit": "Edit team member",
    "team.empty": "It's just you so far",
    "team.empty.sub": "Add your team and front-desk staff so customers can book them.",
    "team.col.name": "Name",
    "team.col.role": "Role",
    "team.col.access": "Access",
    "team.access.login": "Signs in",
    "team.access.invited": "Invited",
    "team.access.kiosk": "PIN only (shared tablet)",
    "team.access.none": "No access",
    "team.removeConfirm": "Remove {name} from your team?",
    "team.removeBody": "If they already have appointments or sales they're deactivated instead, so your history stays intact.",
    "team.removed": "Team member removed",
    "team.deactivated": "Team member deactivated",
    "team.saved": "Team member saved",
    "team.readOnly": "Only the owner can change the team.",
    "addons.title": "Add-ons",
    "addons.sub": "Turn on extra modules when you need them. Modules you don't use stay out of your way.",
    "addons.active": "Active",
    "addons.available": "Available",
    "addons.perMonth": "{price}/mo",
    "addons.perUnit": "{price}/mo per {unit}",
    "addons.usage": "Usage based",
    "addons.request": "Coming soon",
    "addons.requestHint": "Self-serve add-ons arrive with online billing.",
    "addons.open": "Open",
    "addon.extra_branch.name": "Additional location",
    "addon.extra_branch.desc": "Run more locations under one account.",
    "addon.staff_seats.name": "Extra staff seats",
    "addon.staff_seats.desc": "More team members than the Base plan includes.",
    "addon.packages_memberships.name": "Packages & memberships",
    "addon.packages_memberships.desc": "Prepaid packages, memberships and stored value.",
    "addon.payroll_commission.name": "Automatic payroll",
    "addon.payroll_commission.desc": "Commission rules, attendance and payroll approval.",
    "addon.inventory.name": "Inventory",
    "addon.inventory.desc": "Products, consumables, purchasing and stock levels.",
    "addon.booking_website.name": "Website system",
    "addon.booking_website.desc": "Your own website with online booking and custom domain.",
    "addon.whatsapp_notifications.name": "WhatsApp reminders",
    "addon.whatsapp_notifications.desc": "Reminders from your own WhatsApp Business number.",
    "addon.advanced_reports.name": "Advanced reports",
    "addon.advanced_reports.desc": "Multi-location analytics and scheduled exports.",
    "help.stripe.title": "Connect your own Stripe account",
    "help.stripe.intro": "Stripe is a payment company used by millions of businesses. Your salon keeps its own Stripe account, so card payments land directly in your bank account.",
    "help.stripe.s1.title": "1. Create a Stripe account",
    "help.stripe.s1.body": "Go to stripe.com and sign up with your business email. Choose the country where your salon is registered.",
    "help.stripe.s2.title": "2. Verify your business",
    "help.stripe.s2.body": "Stripe asks for your business details, a representative's ID and the bank account for payouts. Keep your registration documents ready.",
    "help.stripe.s3.title": "3. Connect it here",
    "help.stripe.s3.body": "In Settings → Payments press Connect Stripe and sign in to your Stripe account. You'll come back here when it's done.",
    "help.stripe.s4.title": "4. Take payments",
    "help.stripe.s4.body": "Card payments at checkout and online deposits are paid into your Stripe balance and then to your bank on Stripe's payout schedule.",
    "help.stripe.fees": "Stripe charges its own processing fees per payment. The platform does not hold your funds or add a payment fee.",
    "help.stripe.open": "Open stripe.com",
    "help.back": "Back",
  },
  zh: {
    "overview.greeting.morning": "早安，{name}",
    "overview.greeting.afternoon": "午安，{name}",
    "overview.greeting.evening": "晚上好，{name}",
    "overview.sub": "{branch} · 今天",
    "overview.collected": "今日收款",
    "overview.appointments": "今日预约",
    "overview.appointments.sub": "已完成 {n} 个",
    "overview.avgTicket": "平均客单价",
    "overview.avgTicket.sub": "{n} 笔已付款",
    "overview.newCustomers": "新顾客",
    "overview.newCustomers.sub": "最近 7 天",
    "overview.actions": "待办",
    "overview.allClear": "一切就绪。",
    "overview.allClear.sub": "未付定金、挂单、设置步骤等新任务会显示在这里。",
    "overview.newSale": "新建销售",
    "overview.noBranch": "请在设置中添加门店以查看今日数据。",
    "overview.action.verify_email": "确认您的邮箱地址",
    "overview.action.pending_deposits": "{n} 个预约等待支付定金",
    "overview.action.held_sales": "{n} 笔挂单",
    "overview.action.connect_payments": "选择银行卡收款方式",
    "overview.action.add_services": "添加服务项目",
    "overview.action.add_team": "邀请团队成员",
    "settings.title": "设置",
    "settings.tab.salon": "店铺",
    "settings.tab.locations": "门店",
    "settings.tab.payments": "收款",
    "settings.tab.plan": "套餐与账单",
    "settings.salon.title": "店铺资料",
    "settings.salon.sub": "名称、标志以及新门店使用的默认设置。",
    "settings.salon.saved": "店铺资料已保存",
    "settings.salon.removeLogo": "移除标志",
    "settings.salon.subscriptionUsd": "无论您以何种货币销售，Senvia POS 订阅均以美元计费。",
    "settings.locations.title": "门店",
    "settings.locations.sub": "每个门店的营业时间、时区、税务和收银规则。",
    "settings.locations.add": "添加门店",
    "settings.locations.hours": "营业时间",
    "settings.locations.region": "地区",
    "settings.locations.checkout": "收银",
    "settings.locations.inherit": "与店铺相同（{value}）",
    "settings.locations.locked": "已锁定",
    "settings.locations.lockedBody": "该门店已有销售记录，货币无法更改。如需使用其他货币，请新开门店。",
    "settings.locations.discountLimit": "收银员折扣上限（%）",
    "settings.locations.noTax": "不收税",
    "settings.locations.incl": "含税",
    "settings.locations.excl": "不含税",
    "settings.locations.saved": "门店已保存",
    "settings.locations.created": "门店已添加",
    "settings.locations.planLimit": "您的套餐包含一个门店。添加“额外门店”加购模块即可开设更多门店。",
    "settings.locations.closedDays": "休息",
    "settings.payments.title": "收款",
    "settings.payments.explain": "顾客的银行卡付款进入您自己的 Stripe 账户，平台从不经手您的资金。",
    "settings.payments.connect": "连接 Stripe",
    "settings.payments.tutorial": "分步指南",
    "settings.payments.stub": "此版本中 Stripe 连接为预览功能，暂不会创建真实账户。",
    "settings.payments.manual": "仅使用现金和手动收款",
    "settings.payments.manualOn": "您目前使用现金和手动收款，随时可以连接 Stripe。",
    "settings.payments.status.not_connected": "未连接",
    "settings.payments.status.pending": "等待验证",
    "settings.payments.status.restricted": "需要处理",
    "settings.payments.status.active": "已连接",
    "settings.plan.title": "套餐与账单",
    "settings.plan.current": "当前套餐",
    "settings.plan.perMonth": "每月 {price}",
    "settings.plan.trialEnds": "试用期至 {date}",
    "settings.plan.addons": "已启用的加购模块",
    "settings.plan.noAddons": "尚未添加加购模块。",
    "settings.plan.browse": "浏览加购模块",
    "settings.plan.billingLater": "订阅在线付款即将推出，试用期间不会收费。",
    "team.title": "团队",
    "team.sub": "负责预约或使用收银的人员。",
    "team.add": "添加团队成员",
    "team.edit": "编辑团队成员",
    "team.empty": "目前只有您一人",
    "team.empty.sub": "添加服务团队和前台人员，顾客即可预约他们。",
    "team.col.name": "姓名",
    "team.col.role": "角色",
    "team.col.access": "访问方式",
    "team.access.login": "可登录",
    "team.access.invited": "已邀请",
    "team.access.kiosk": "仅 PIN（共用平板）",
    "team.access.none": "无访问权限",
    "team.removeConfirm": "将 {name} 移出团队？",
    "team.removeBody": "如其已有预约或销售记录，将改为停用，以保留历史数据。",
    "team.removed": "已移除团队成员",
    "team.deactivated": "已停用团队成员",
    "team.saved": "团队成员已保存",
    "team.readOnly": "只有店主可以更改团队。",
    "addons.title": "加购模块",
    "addons.sub": "需要时再开启额外模块，不用的模块不会打扰您。",
    "addons.active": "已启用",
    "addons.available": "可添加",
    "addons.perMonth": "{price}/月",
    "addons.perUnit": "每{unit} {price}/月",
    "addons.usage": "按用量计费",
    "addons.request": "即将推出",
    "addons.requestHint": "自助开通将随在线账单一同推出。",
    "addons.open": "打开",
    "addon.extra_branch.name": "额外门店",
    "addon.extra_branch.desc": "在一个账户下经营更多门店。",
    "addon.staff_seats.name": "额外员工名额",
    "addon.staff_seats.desc": "超出基础版人数的团队成员。",
    "addon.packages_memberships.name": "套餐卡与会员",
    "addon.packages_memberships.desc": "预付套餐、会员和储值。",
    "addon.payroll_commission.name": "自动算薪",
    "addon.payroll_commission.desc": "提成规则、考勤和工资审批。",
    "addon.inventory.name": "库存",
    "addon.inventory.desc": "产品、耗材、采购和库存水平。",
    "addon.booking_website.name": "网站系统",
    "addon.booking_website.desc": "拥有在线预约和自定义域名的专属网站。",
    "addon.whatsapp_notifications.name": "WhatsApp 提醒",
    "addon.whatsapp_notifications.desc": "通过您自己的 WhatsApp Business 号码发送提醒。",
    "addon.advanced_reports.name": "高级报表",
    "addon.advanced_reports.desc": "多门店分析和定时导出。",
    "help.stripe.title": "连接您自己的 Stripe 账户",
    "help.stripe.intro": "Stripe 是数百万企业使用的支付公司。您的店铺拥有自己的 Stripe 账户，银行卡款项直接进入您的银行账户。",
    "help.stripe.s1.title": "1. 创建 Stripe 账户",
    "help.stripe.s1.body": "前往 stripe.com，用企业邮箱注册，并选择店铺注册所在的国家/地区。",
    "help.stripe.s2.title": "2. 验证您的企业",
    "help.stripe.s2.body": "Stripe 会要求提供企业信息、负责人身份证件和收款银行账户，请准备好注册文件。",
    "help.stripe.s3.title": "3. 在此连接",
    "help.stripe.s3.body": "在 设置 → 收款 中点击“连接 Stripe”并登录您的 Stripe 账户，完成后会自动返回。",
    "help.stripe.s4.title": "4. 开始收款",
    "help.stripe.s4.body": "收银时的银行卡付款和线上定金会进入您的 Stripe 余额，然后按 Stripe 的结算周期转入您的银行。",
    "help.stripe.fees": "Stripe 会按笔收取其自身的手续费。平台不经手您的资金，也不额外收取支付费用。",
    "help.stripe.open": "打开 stripe.com",
    "help.back": "返回",
  },
  ms: {
    "overview.greeting.morning": "Selamat pagi, {name}",
    "overview.greeting.afternoon": "Selamat petang, {name}",
    "overview.greeting.evening": "Selamat malam, {name}",
    "overview.sub": "{branch} · hari ini",
    "overview.collected": "Kutipan hari ini",
    "overview.appointments": "Temujanji hari ini",
    "overview.appointments.sub": "{n} selesai",
    "overview.avgTicket": "Purata jualan",
    "overview.avgTicket.sub": "{n} jualan dibayar",
    "overview.newCustomers": "Pelanggan baharu",
    "overview.newCustomers.sub": "7 hari lepas",
    "overview.actions": "Perlu dibuat",
    "overview.allClear": "Semuanya beres.",
    "overview.allClear.sub": "Tugasan baharu — deposit belum dibayar, jualan ditangguh, langkah persediaan — dipaparkan di sini.",
    "overview.newSale": "Jualan baharu",
    "overview.noBranch": "Tambah lokasi dalam Tetapan untuk melihat angka hari ini.",
    "overview.action.verify_email": "Sahkan alamat e-mel anda",
    "overview.action.pending_deposits": "{n} tempahan menunggu deposit",
    "overview.action.held_sales": "{n} jualan ditangguhkan",
    "overview.action.connect_payments": "Pilih cara menerima bayaran kad",
    "overview.action.add_services": "Tambah perkhidmatan anda",
    "overview.action.add_team": "Jemput pasukan anda",
    "settings.title": "Tetapan",
    "settings.tab.salon": "Salun",
    "settings.tab.locations": "Lokasi",
    "settings.tab.payments": "Bayaran",
    "settings.tab.plan": "Pelan & bil",
    "settings.salon.title": "Profil salun",
    "settings.salon.sub": "Nama, logo dan tetapan lalai untuk lokasi baharu.",
    "settings.salon.saved": "Profil salun disimpan",
    "settings.salon.removeLogo": "Buang logo",
    "settings.salon.subscriptionUsd": "Langganan Senvia POS anda dibilkan dalam USD tanpa mengira mata wang jualan anda.",
    "settings.locations.title": "Lokasi",
    "settings.locations.sub": "Waktu operasi, zon waktu, cukai dan peraturan kaunter bagi setiap lokasi.",
    "settings.locations.add": "Tambah lokasi",
    "settings.locations.hours": "Waktu operasi",
    "settings.locations.region": "Wilayah",
    "settings.locations.checkout": "Kaunter bayaran",
    "settings.locations.inherit": "Sama seperti salun ({value})",
    "settings.locations.locked": "Dikunci",
    "settings.locations.lockedBody": "Lokasi ini sudah ada jualan, jadi mata wangnya tidak boleh diubah. Buka lokasi baharu untuk menjual dalam mata wang lain.",
    "settings.locations.discountLimit": "Had diskaun juruwang (%)",
    "settings.locations.noTax": "Tiada cukai",
    "settings.locations.incl": "termasuk",
    "settings.locations.excl": "tidak termasuk",
    "settings.locations.saved": "Lokasi disimpan",
    "settings.locations.created": "Lokasi ditambah",
    "settings.locations.planLimit": "Pelan anda termasuk satu lokasi. Tambah tambahan Lokasi Tambahan untuk membuka lebih banyak.",
    "settings.locations.closedDays": "Tutup",
    "settings.payments.title": "Bayaran",
    "settings.payments.explain": "Bayaran kad pelanggan masuk ke akaun Stripe anda sendiri. Platform tidak pernah memegang wang anda.",
    "settings.payments.connect": "Sambung Stripe",
    "settings.payments.tutorial": "Panduan langkah demi langkah",
    "settings.payments.stub": "Sambungan Stripe dalam pratonton bagi versi ini — tiada akaun sebenar dicipta lagi.",
    "settings.payments.manual": "Tunai & bayaran manual sahaja",
    "settings.payments.manualOn": "Anda menerima tunai dan bayaran manual. Anda boleh menyambung Stripe bila-bila masa.",
    "settings.payments.status.not_connected": "Tidak disambung",
    "settings.payments.status.pending": "Menunggu pengesahan",
    "settings.payments.status.restricted": "Tindakan diperlukan",
    "settings.payments.status.active": "Disambung",
    "settings.plan.title": "Pelan & bil",
    "settings.plan.current": "Pelan semasa",
    "settings.plan.perMonth": "{price} / bulan",
    "settings.plan.trialEnds": "Percubaan tamat {date}",
    "settings.plan.addons": "Tambahan aktif",
    "settings.plan.noAddons": "Belum ada tambahan.",
    "settings.plan.browse": "Lihat tambahan",
    "settings.plan.billingLater": "Bil dalam talian untuk langganan anda akan tiba tidak lama lagi. Tiada caj semasa percubaan.",
    "team.title": "Pasukan",
    "team.sub": "Orang yang menerima temujanji atau menggunakan kaunter.",
    "team.add": "Tambah ahli pasukan",
    "team.edit": "Sunting ahli pasukan",
    "team.empty": "Hanya anda buat masa ini",
    "team.empty.sub": "Tambah pasukan anda dan staf kaunter supaya pelanggan boleh menempah mereka.",
    "team.col.name": "Nama",
    "team.col.role": "Peranan",
    "team.col.access": "Akses",
    "team.access.login": "Boleh log masuk",
    "team.access.invited": "Dijemput",
    "team.access.kiosk": "PIN sahaja (tablet dikongsi)",
    "team.access.none": "Tiada akses",
    "team.removeConfirm": "Buang {name} daripada pasukan anda?",
    "team.removeBody": "Jika mereka sudah ada temujanji atau jualan, mereka akan dinyahaktifkan supaya sejarah anda kekal.",
    "team.removed": "Ahli pasukan dibuang",
    "team.deactivated": "Ahli pasukan dinyahaktifkan",
    "team.saved": "Ahli pasukan disimpan",
    "team.readOnly": "Hanya pemilik boleh mengubah pasukan.",
    "addons.title": "Tambahan",
    "addons.sub": "Hidupkan modul tambahan apabila perlu. Modul yang tidak digunakan tidak akan mengganggu anda.",
    "addons.active": "Aktif",
    "addons.available": "Tersedia",
    "addons.perMonth": "{price}/bln",
    "addons.perUnit": "{price}/bln setiap {unit}",
    "addons.usage": "Ikut penggunaan",
    "addons.request": "Akan datang",
    "addons.requestHint": "Tambahan layan diri tiba bersama bil dalam talian.",
    "addons.open": "Buka",
    "addon.extra_branch.name": "Lokasi tambahan",
    "addon.extra_branch.desc": "Uruskan lebih banyak lokasi di bawah satu akaun.",
    "addon.staff_seats.name": "Tempat staf tambahan",
    "addon.staff_seats.desc": "Lebih ramai ahli pasukan daripada yang termasuk dalam Pelan Asas.",
    "addon.packages_memberships.name": "Pakej & keahlian",
    "addon.packages_memberships.desc": "Pakej prabayar, keahlian dan nilai tersimpan.",
    "addon.payroll_commission.name": "Gaji & komisen",
    "addon.payroll_commission.desc": "Peraturan komisen, kehadiran dan kelulusan gaji.",
    "addon.inventory.name": "Inventori",
    "addon.inventory.desc": "Produk, bahan guna habis, pembelian dan paras stok.",
    "addon.booking_website.name": "Laman web tempahan",
    "addon.booking_website.desc": "Laman web sendiri dengan tempahan dalam talian dan domain tersendiri.",
    "addon.whatsapp_notifications.name": "Peringatan WhatsApp",
    "addon.whatsapp_notifications.desc": "Peringatan daripada nombor WhatsApp Business anda sendiri.",
    "addon.advanced_reports.name": "Laporan lanjutan",
    "addon.advanced_reports.desc": "Analitik pelbagai lokasi dan eksport berjadual.",
    "help.stripe.title": "Sambungkan akaun Stripe anda sendiri",
    "help.stripe.intro": "Stripe ialah syarikat pembayaran yang digunakan oleh berjuta-juta perniagaan. Salun anda mempunyai akaun Stripe sendiri, jadi bayaran kad masuk terus ke akaun bank anda.",
    "help.stripe.s1.title": "1. Cipta akaun Stripe",
    "help.stripe.s1.body": "Pergi ke stripe.com dan daftar dengan e-mel perniagaan anda. Pilih negara tempat salun anda didaftarkan.",
    "help.stripe.s2.title": "2. Sahkan perniagaan anda",
    "help.stripe.s2.body": "Stripe akan meminta butiran perniagaan, ID wakil dan akaun bank untuk pembayaran. Sediakan dokumen pendaftaran anda.",
    "help.stripe.s3.title": "3. Sambungkan di sini",
    "help.stripe.s3.body": "Dalam Tetapan → Bayaran tekan Sambung Stripe dan log masuk ke akaun Stripe anda. Anda akan kembali ke sini apabila selesai.",
    "help.stripe.s4.title": "4. Terima bayaran",
    "help.stripe.s4.body": "Bayaran kad di kaunter dan deposit dalam talian dimasukkan ke baki Stripe anda, kemudian ke bank mengikut jadual pembayaran Stripe.",
    "help.stripe.fees": "Stripe mengenakan yuran pemprosesannya sendiri bagi setiap bayaran. Platform tidak memegang dana anda atau menambah yuran bayaran.",
    "help.stripe.open": "Buka stripe.com",
    "help.back": "Kembali",
  },
});
